import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { EnumCorpSize, EnumCorpTypePb } from "./corp-progress-bar.enum";
import { NgTemplateOutlet } from "@angular/common";

@Component({
    selector: 'corp-progress-bar',
    standalone: true,
    templateUrl: 'corp-progress-bar.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgTemplateOutlet]
  })
  export class CorpProgressBarComponent  {
    @Input("corp-type")     corpType:   EnumCorpTypePb = EnumCorpTypePb.default; //button
    @Input("corp-label")    corpLabel:  string = '';
    @Input("corp-color")    corpColor:  string = 'bg-primary-300';
    @Input("corp-size")     corpSize:   EnumCorpSize = EnumCorpSize.default; // 'h-2.5';
    @Input("corp-value")    corpValue:  string = '0';

    size: string = '';
    enumCorpTypePb= EnumCorpTypePb;

    constructor(

    ) {

    }


  ngOnInit(): void {
    switch(this.corpSize) {
        case EnumCorpSize.small:
            this.size='h-1.5';
            break;
        case EnumCorpSize.default:
            this.size='h-2.5';
            break;
        case EnumCorpSize.large:
            this.size='h-4';
            break;
        case EnumCorpSize.extraLarge:
            this.size='h-6';
            break;
    }
  }

}